import React from 'react';
import { Text, Colors } from 'library';
import { PastShift } from '../models';
import { styled, Grid } from '@mui/material';
import { format12HourTime, formatShortMonthDayYear } from 'shared/Dates';
import { locationAddress } from './utils';
import { differenceInMinutes } from 'date-fns';

export default function ShiftCard({ shift }: { shift: PastShift }) {
    const tardy =
        !!shift.appointment && differenceInMinutes(new Date(shift.appointment.start_date), new Date(shift.start)) < -5;
    return (
        <Container item container xs={12} md={3} direction="column" tardy={tardy}>
            <TitleContainer>
                <Text bold>{formatShortMonthDayYear(shift.start)}</Text>
                <Text textStyle={{ border: `1px ${Colors.darkNavy} solid`, padding: '0 2px' }} variant="caption">
                    {shift.business_job_type?.replace('_', ' ')}
                </Text>
            </TitleContainer>
            {shift.late_minutes ? <Text variant="caption">(Reported late: {shift.late_minutes} minutes)</Text> : null}
            {shift.business_location ? (
                <>
                    <Text>{shift.business_location.name}</Text>
                    <Text variant="caption">{locationAddress(shift.business_location)}</Text>
                </>
            ) : null}
            {shift.appointment ? (
                <TextContainer direction="row" justifyContent="space-between" container item>
                    <Text variant="caption">Shift Start: {format12HourTime(shift.appointment.start_date)}</Text>
                    <Text variant="caption">Shift End: {format12HourTime(shift.appointment.end_date)}</Text>
                </TextContainer>
            ) : null}
            <TextContainer direction="row" justifyContent="space-between" container item>
                <Text variant="caption">Clock In: {format12HourTime(shift.start)}</Text>
                <Text variant="caption">Clock Out: {format12HourTime(shift.end)}</Text>
            </TextContainer>
            {shift.approved_break > 0 ? <Text variant="caption">Break: {shift.approved_break} minutes</Text> : null}
            <TextContainer direction="row" justifyContent="space-between" container item>
                <Text variant="caption">Hours Worked: {shift.hours_worked}</Text>
                {shift.provider_rate ? <Text variant="caption">Rate: ${shift.provider_rate}/hr</Text> : null}
            </TextContainer>
            <Text variant="caption">Payment: {shift.paid_amount ? `$${shift.paid_amount}` : 'Pending'}</Text>
        </Container>
    );
}

const TitleContainer = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
});

const Container = styled(Grid)(({ tardy }: { tardy: boolean }) => ({
    backgroundColor: tardy ? Colors.lightRed : Colors.lightTurq,
    padding: 20,
    borderRadius: 18,
}));

const TextContainer = styled(Grid)({
    marginTop: 10,
});
